/* BRAZILINA : toggle "À plat | Porté" sur les cartes de la PAGE COLLECTION uniquement (mobile) */
(function () {
  function isCollection() { return document.body && document.body.classList.contains('template-collection'); }
  function isMobile() { return window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches; }
  function viewLabels() {
    var p = (location.pathname || '').toLowerCase();
    /* BRAZILINA-ALL-VUE12 : /collections/all uniquement */
    if (p.indexOf('/collections/all') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('culotte') !== -1) return ['De face', 'De dos'];
    if (p.indexOf('t-shirt-bresil') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('casquette') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('top-bresil') !== -1) return ['À plat', 'Porté'];
    if (p.indexOf('maillot-de-bain') !== -1 || p.indexOf('bikini') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('tote-bag') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('affiche') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('coque') !== -1) return ['Vue 1', 'Vue 2'];
    /* packs : un lot, ni à plat ni porté */
    if (p.indexOf('packs-bresil') !== -1) return ['Vue 1', 'Vue 2'];
    return ['À plat', 'Porté'];
  }
  function directChild(el, tag) {
    for (var i = 0; i < el.children.length; i++) if (el.children[i].tagName === tag) return el.children[i];
    return null;
  }
  function directChildren(el, tag) {
    var out = [];
    for (var i = 0; i < el.children.length; i++) if (el.children[i].tagName === tag) out.push(el.children[i]);
    return out;
  }
  function initOne(fig) {
    if (fig.dataset.brzInit) return;
    var a = directChild(fig, 'A'); if (!a) return;
    var pics = directChildren(a, 'PICTURE'); if (pics.length < 2) return;
    fig.dataset.brzInit = '1';

    var tog = document.createElement('div');
    tog.className = 'brz-view-toggle';
    var L = viewLabels();
    tog.innerHTML = '<span class="brz-seg brz-seg-flat on" role="button" tabindex="0">' + L[0] + '</span>'
                  + '<span class="brz-seg brz-seg-worn" role="button" tabindex="0">' + L[1] + '</span>';
    var segFlat = tog.querySelector('.brz-seg-flat');
    var segWorn = tog.querySelector('.brz-seg-worn');
    var modePC = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function goTo(idx, e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (modePC) {
        fig.classList.toggle('brz-worn', idx === 1);
        segFlat.classList.toggle('on', idx === 0);
        segWorn.classList.toggle('on', idx !== 0);
        return;
      }
      a.scrollTo({ left: idx * a.clientWidth, behavior: 'smooth' });
    }
    segFlat.addEventListener('click', function (e) { goTo(0, e); });
    segWorn.addEventListener('click', function (e) { goTo(1, e); });
    fig.appendChild(tog);

    var raf = null;
    a.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var idx = Math.round(a.scrollLeft / Math.max(1, a.clientWidth));
        segFlat.classList.toggle('on', idx === 0);
        segWorn.classList.toggle('on', idx !== 0);
      });
    }, { passive: true });
  }
  function initAll() {
    /* BRAZILINA-TOGGLE-MOBILE-ONLY : les toggles n'existent QUE sur mobile ;
       sur PC c'est le survol qui échange les images (règle boutique, 07/08). */
    if (!isCollection() || !isMobile()) return;
    var figs = document.querySelectorAll('.l4cl li.second-img-hover:not(.second-img-first) > figure');
    for (var i = 0; i < figs.length; i++) initOne(figs[i]);
  }
  var deb = null;
  function initDebounced() { clearTimeout(deb); deb = setTimeout(initAll, 150); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initDebounced);
  if (window.MutationObserver && isCollection()) {
    var host = document.querySelector('#main-collection, .shopify-section-collection, main') || document.body;
    new MutationObserver(initDebounced).observe(host, { childList: true, subtree: true });
  }
})();

/* BRAZILINA-OPTION-SCROLL v2 : fiche produit — l'option choisie coulisse en vue dans
   les rangees qui defilent. Le theme REDESSINE le selecteur apres le changement ->
   scroll DIFFERE avec re-requete du DOM (2 passes). */
(function () {
  function glisse() {
    var rangees = document.querySelectorAll('.check');
    for (var i = 0; i < rangees.length; i++) {
      var r = rangees[i];
      if (r.scrollWidth <= r.clientWidth + 4) continue;
      var coche = r.querySelector('input[type="radio"]:checked');
      if (!coche) continue;
      var li = coche.closest('li');
      var lab = li && (li.querySelector('label') || li);
      if (!lab) continue;
      var br = r.getBoundingClientRect(), bl = lab.getBoundingClientRect();
      if (bl.right > br.right - 4 || bl.left < br.left + 4) {
        r.scrollTo({ left: r.scrollLeft + (bl.left - br.left) - (br.width - bl.width) / 2, behavior: 'smooth' });
      }
    }
  }
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    setTimeout(glisse, 350);
    setTimeout(glisse, 900);
  }, true);
})();
/* refresh */
